import { Injectable } from '@angular/core';
import { randomUUID } from '@shared/lib/utils/random';
import { type Resettable } from '@shared/config/app-reset.service';

@Injectable({ providedIn: 'root' })
export class RedeemIdempotencyService implements Resettable {
  private key = '';
  private keyFor = '';

  forBody(body: string): string {
    if (this.keyFor !== body) {
      this.keyFor = body;
      this.key = randomUUID();
    }
    return this.key;
  }

  clear(): void {
    this.keyFor = '';
  }

  reset(): void {
    this.clear();
  }
}
